import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { APIProviderContext } from "../api";
import { PulseLoader } from "react-spinners";
import { useSearchParams } from "react-router-dom";
import LIMITS from "../../pages/settings/limits";
import { WhiteLabelContext } from "../whitelabel";
import { AppsumoIcon } from "../../assets/ui-icons";
import Modal from "./dashboardModal";

const GrigoraAccountContext = createContext();

var enterpriseDomains = ["@grigora.co", "@latracal.com"];

const GrigoraAccount = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isAppsumoModalVisible, setIsAppsumoModalVisible] = useState(false);

  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { isWhitelabel, whitelabelPlans, isWhiteLabelOwner } =
    useContext(WhiteLabelContext) ?? {};

  const { getUserData } = useContext(APIProviderContext);

  const [isSaasZillaCampaignVisible, setIsSaasZillaCampaignVisible] =
    useState(false);

  useEffect(() => {
    setIsLoading(true);

    getUserData()
      .then((data) => {
        setUserData(data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (searchParams?.get("appsumo") === "connected") {
      setSearchParams({});
      setIsAppsumoModalVisible(true);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!isLoading) {
    }
  }, [isLoading]);

  const isSubscribed = useMemo(() => {
    if (enterpriseDomains.some((domain) => userData?.email?.endsWith(domain))) {
      return true;
    }

    return userData?.subscription?.status === "active";
  }, [userData?.subscription?.status]);

  const subscriptionPlan = useMemo(() => {
    if (enterpriseDomains.some((domain) => userData?.email?.endsWith(domain))) {
      return "enterprise";
    }

    return userData?.subscription?.plan ?? "free";
  }, [userData?.subscription?.plan]);

  const subscriptionLimits = useMemo(() => {
    if (!isSubscribed) {
      return LIMITS.free;
    }

    if (isWhitelabel && !isWhiteLabelOwner) {
      return whitelabelPlans?.[subscriptionPlan]?.limits ?? LIMITS.free;
    }

    return LIMITS[subscriptionPlan] ?? LIMITS.free;
  }, [
    isSubscribed,
    subscriptionPlan,
    whitelabelPlans,
    isWhitelabel,
    isWhiteLabelOwner,
  ]);

  return (
    <GrigoraAccountContext.Provider
      value={{
        userData,
        setUserData,
        isSubscribed,
        subscriptionPlan,
        subscriptionLimits,
      }}
    >
      <Modal
        isOpened={isAppsumoModalVisible}
        setOpened={setIsAppsumoModalVisible}
        icon={<AppsumoIcon className="w-[100px] h-[100px] mx-auto" />}
        heading="Appsumo License Activated"
        content={
          <p className="mb-5">
            Hello Sumo-ling! 👋 <br></br>Your Appsumo license has been
            successfully activated.<br></br> Enjoy your Grigora experience!
          </p>
        }
      />
      {isLoading ? (
        <div className="w-full h-screen flex items-center justify-center">
          <PulseLoader color="black" size={6} />
        </div>
      ) : (
        props.children
      )}
    </GrigoraAccountContext.Provider>
  );
};
export { GrigoraAccount, GrigoraAccountContext };
